import { render, staticRenderFns } from "./VoucherEmptyState.vue?vue&type=template&id=fd82efd4&scoped=true"
import script from "./VoucherEmptyState.vue?vue&type=script&lang=js"
export * from "./VoucherEmptyState.vue?vue&type=script&lang=js"
import style0 from "./VoucherEmptyState.vue?vue&type=style&index=0&id=fd82efd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd82efd4",
  null
  
)

export default component.exports